import * as angular from 'angular';
import { KeyValuePair, IdentifierType, IValueTypeSelector } from '../../models';
import { ObjectType } from '../../models/enum/ObjectType';
import { tagDefinitionValues, validatedValues, targetValues, identifierValues, reconciledValues, reconciledConstraints } from '../../common';
import { ValueTypes } from '../../common/ValueTypes';

export interface IValueTypeHelperService {
    getViewModelValueTypes(vm: IValueTypeSelector, isQuery?: boolean): KeyValuePair<string, string>[];
    getIdentifierValueTypes(type: number): KeyValuePair<string, string>[];
    isValueTypePercent(type: string): boolean;
}

export class ValueTypeHelperService implements IValueTypeHelperService {
    static serviceId = 'valueTypeHelperService';
    static $inject = [];

    getViewModelValueTypes(vm: IValueTypeSelector, isQuery: boolean = false): KeyValuePair<string, string>[] {
        let result: KeyValuePair<string, string>[] = [];
        if (isQuery) {
            if (!vm.valueTypes?.length || (vm.valueTypes.length === 1 && !vm.valueTypes[0])) {
                // It seems that when IdentifierQuery haven't any valueTypes defined, the list contains an empty element
                result = ValueTypes.allValueTypes;
            } else {
                result = ValueTypes.allValueTypes.filter(vt => vm.valueTypes.indexOf(vt.key) >= 0);
            }
        } else {
            const type: number = vm.identifierType;
            if (vm.objectType === ObjectType.Tag) {
                result = tagDefinitionValues.map(d => d);
            } else if (vm.objectType === ObjectType.HistorianTag) {
                result = [ValueTypes.raw];
            } else {
                result = this.getIdentifierValueTypes(type);
            }

            if (vm.hasReconciledValue) {
                result = result.concat(reconciledValues);
            }

            if (vm.isConstraint) {
                result = result.concat(reconciledConstraints);
            }
        }

        return result;
    }

    getIdentifierValueTypes(type: number): KeyValuePair<string, string>[] {
        let result: KeyValuePair<string, string>[] = [];

        switch (type) {
            case IdentifierType.Tag:
                result = tagDefinitionValues.map(d => d);
                break;
            case IdentifierType.CalculatedValue:
                result = identifierValues.map(d => d);
                break;
            case IdentifierType.Validated:
                result = validatedValues.map(d => d);
                break;
            case IdentifierType.Target:
                result = targetValues.map(d => d);
                break;
            default:
                console.log(`Unknwon identifier type ${type}`);
        }

        return result;
    }

    isValueTypePercent(type: string): boolean {
        return type === ValueTypes.relativeDeviation.key;
    }
}